// D-1130: 「〇〇しました 元に戻す」を画面下に 5 秒出す部品(Material 3 Snackbar / Apple HIG Undo の形)。
//   toast = { id, message, error? } を親が持つ。id が変わるたびに 5 秒を数え直す。error は赤い 1 行。onUndo が無ければボタンは出さない。
//   gate_3 △2: busy(元に戻す通信中)の間は数えない。busy が終わったとき・error が付いたときに 5 秒を数え直す(失敗が見える時間を確保)。
import { useEffect, useRef } from 'react'

export const UNDO_TOAST_MS = 5000

export default function UndoToast({ toast, onUndo, onClose, busy = false, testId = 'undo-toast' }) {
  const closeRef = useRef(onClose)
  closeRef.current = onClose
  const id = toast?.id
  const error = toast?.error
  useEffect(() => {
    if (id == null || busy) return undefined
    const t = setTimeout(() => closeRef.current?.(), UNDO_TOAST_MS)
    return () => clearTimeout(t)
  }, [id, busy, error])
  if (!toast) return null
  return (
    <div
      role="status"
      data-testid={testId}
      className="fixed left-0 right-0 z-[60] px-4 flex justify-center pointer-events-none"
      style={{ bottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)' }}
    >
      <div className="pointer-events-auto w-full max-w-md rounded-xl bg-slate-800 border border-slate-600 text-slate-100 shadow-lg px-4 py-2 flex items-center gap-3">
        <div className="flex-1 min-w-0 text-base">
          <p data-testid={`${testId}-message`}>{toast.message}</p>
          {toast.error && <p data-testid={`${testId}-error`} className="text-red-300 text-sm mt-0.5">{toast.error}</p>}
        </div>
        {onUndo && (
          <button
            type="button"
            data-testid={`${testId}-undo`}
            onClick={onUndo}
            disabled={busy}
            className="shrink-0 min-h-[44px] min-w-[44px] px-3 rounded-lg text-base font-bold text-blue-300 active:text-blue-200 disabled:opacity-50"
          >
            元に戻す
          </button>
        )}
      </div>
    </div>
  )
}
